<template>
    <v-app class="grey lighten-4">
        <Navbar
            v-if="$route && !dontShowNavbarPages.includes($route.name)"
        />
        <v-main>
            <v-snackbar
                :timeout="-1"
                :value="!ibansFilled"
                bottom
                right
                rounded="pill"
                color="gray accent-4"
                elevation="24"
                v-if="$route.name !== 'integration-edit'"
            >
                {{ "You have not entered the required payment information" | t }}
                <template v-slot:action="{ attrs }">
                    <v-btn color="grey" text v-bind="attrs" @click="$router.push({ name: 'integration-edit' })">
                        Edit
                    </v-btn>
                </template>
            </v-snackbar>
            <v-snackbar color="error" bottom :timeout="2500" :value="requestError">
                <div style="display: flex">
                    <v-icon color="#FFF">error</v-icon>
                    <div class="title pa-2 ">{{ errorMessage | t }}</div>
                </div>
            </v-snackbar>
            <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
                <div style="display: flex">
                    <v-icon color="#FFF">check</v-icon>
                    <div class="title pa-2 ">{{ "Success" | t }}</div>
                </div>
            </v-snackbar>
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
import Navbar from "./components/navbar";
import { mapState } from "vuex";
export default {
    name: "App",
    data() {
        return {
            dontShowNavbarPages: ['payment-view', 'payment-done', 'Login', 'payment-info-view', 'account-select-view', 'bulk-payment-view', 'onboarding']
        };
    },
    components: { Navbar },
    computed: { ...mapState(["ibansFilled", "requestError", "errorMessage", "requestSuccess"]) }
};
</script>
<style lang="scss"></style>
